import { addDays, addHours, addMinutes, differenceInDays, format, formatDistance, formatDistanceToNow, isBefore, isSameDay, isValid, parse, parseISO, parseJSON, setHours, subDays, } from "date-fns";
import { de } from "date-fns/locale";
import isString from "lodash/isString";
export const parsedDate = (date, local = true) => {
    if (isString(date)) {
        if (local)
            return parseDateLocal(date);
        return parseDateUtc(date);
    }
    return date;
};
export const parseDateLocal = (date) => {
    let rslt = parseISO(date);
    if (isValid(rslt)) {
        return rslt;
    }
    rslt = parse(date, "yyyy-MM-dd", new Date());
    if (isValid(rslt)) {
        return rslt;
    }
    throw new Error(`Unknown date format: ${date}`);
};
export const parseDateUtc = (date) => {
    let rslt = parseJSON(date);
    if (isValid(rslt)) {
        return rslt;
    }
    rslt = parse(date, "yyyy-MM-dd", new Date());
    if (isValid(rslt)) {
        return rslt;
    }
    throw new Error(`Unknown date format: ${date}`);
};
export const dateFormat = (date, formatStr = undefined, local = true) => format(parsedDate(date, local), formatStr || "d.M.yyyy", { locale: de });
export const timeFormat = (date, formatStr = undefined) => dateFormat(date, formatStr || "H:mm");
export const dateTimeFormat = (date, formatStr = undefined, local = true) => dateFormat(date, formatStr || "d.M.yyyy H:mm", local);
export const detailedDateFormat = (date) => dateFormat(date, "EEEE, d. LLLL yyyy");
export const detailedDateTimeFormat = (date) => dateFormat(date, "EEEE, d. LLLL yyyy, H:mm 'Uhr'");
export const relativeTime = (date, fromDate = new Date(), local = true) => formatDistance(parsedDate(date, local), fromDate, { locale: de, addSuffix: true });
export const indexDateWithTime = (date, fromDate = new Date(), local = false) => {
    date = parsedDate(date, local);
    if (isSameDay(date, fromDate)) {
        return format(date, "H:mm 'Uhr'");
    }
    else if (isSameDay(subDays(fromDate, 1), date)) {
        return format(date, "'gestern,' H:mm 'Uhr'");
    }
    return format(date, "d.M.yyyy',' H:mm 'Uhr'");
};
export const dateToUtc = (date) => addMinutes(date, date.getTimezoneOffset());
export const getFormat = (start, stop) => (differenceInDays(stop, start) < 1 ? "HH:mm" : "dd.MM.");
export const getGroup = (start, stop) => (differenceInDays(stop, start) < 1 ? "hour" : "day");
export const getDateRange = (start, stop, startHour = 7, stopHour = 18) => {
    const categories = [];
    const group = getGroup(start, stop);
    const fun = group === "hour" ? addHours : addDays;
    if (group === "hour") {
        start = setHours(start, startHour);
        stop = setHours(stop, stopHour);
    }
    for (; isBefore(start, stop);) {
        categories.push(start);
        start = fun(start, 1);
    }
    return categories;
};
export const timeOrDateTime = (date) => {
    date = parsedDate(date);
    if (isSameDay(date, new Date())) {
        return timeFormat(date);
    }
    return dateTimeFormat(date);
};
export const dateTimeSince = (dateString) => {
    if (!dateString)
        return "unbekannt";
    const date = parseISO(dateString);
    return `${formatDistanceToNow(date, { locale: de })}`;
};
export const naiveDateTime = (date) => date ? format(dateToUtc(date), "yyyy-MM-dd'T'HH:mm:ss") : undefined;
export const secondsToMinutes = (seconds, withSeconds = false) => {
    let str = "";
    if (seconds < 0) {
        str = "-";
        seconds = Math.abs(seconds);
    }
    const minutes = Math.floor(seconds / 60);
    const restSeconds = Math.floor(seconds % 60);
    str += minutes + "m";
    if (withSeconds && restSeconds > 0) {
        str += " " + restSeconds + "s";
    }
    return str;
};
